import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  MutationSendMessageToMemberArgs,
  NewMessage,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHasChatsKey } from '../../utils/keys/messaging.key.js'
import { CHATS_QUERY } from './constants.js'
import { useRefreshChats } from './useRefreshChats.js'

export const useSendMessageToMember = (
  options?: UseMutationOptions<
    NewMessage,
    ClientError,
    MutationSendMessageToMemberArgs
  >,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const { refreshChats } = useRefreshChats()

  return useMutation<NewMessage, ClientError, MutationSendMessageToMemberArgs>(
    (input: MutationSendMessageToMemberArgs) =>
      client.messaging.sendMessageToMember(input),
    {
      ...(options ?? {}),
      onSuccess: async (data, variables, context) => {
        await refreshChats({
          variables: {
            ...CHATS_QUERY,
          },
          skipUnreadCounts: true,
        })

        const hasChats = queryClient.getQueryData<boolean>(getHasChatsKey())
        if (!hasChats) {
          queryClient.setQueryData(getHasChatsKey(), true)
        }
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context)
        }
      },
    },
  )
}
